module.exports = {
	"name": "otc-admin",
	"version": "2.2.0-1",
	"private": true,
	"scripts": {
		"start": "node scripts/start.js",
		"build": "node scripts/build.js",
		"test": "node scripts/test.js --env=jsdom",
		"lint": "./node_modules/.bin/eslint 'src/**/*.js'",
		"g": "./node_modules/redux-cli/bin/redux.js g"
	},
	"dll": {
		"exclude": [
			"babel-polyfill",
			"slate-editor"
		]
	},
	"pipeline": {
		"veracodeAppName": "web-ui"
	},
	"dependencies": {
		"axios": "^0.16.2",
		"bootstrap": "^4.0.0-alpha.6",
		"cross-storage": "^1.0.0",
		"deep-equal": "^1.0.1",
		"lodash": "^4.17.4",
		"mock-local-storage": "^1.0.4",
		"moment": "^2.18.1",
		"moxios": "^0.4.0",
		"node-sass": "^4.5.3",
		"prop-types": "^15.5.10",
		"query-string": "^5.1.0",
		"react": "^15.6.1",
		"react-addons-css-transition-group": "^15.6.0",
		"react-addons-transition-group": "^15.6.0",
		"react-alert": "^2.2.0",
		"react-autosuggest": "^9.3.2",
		"react-dom": "^15.6.1",
		"react-helmet": "^5.1.3",
		"react-router": "^4.1.1",
		"react-router-dom": "^4.1.1",
		"react-sortable-hoc": "^0.6.7",
		"reactstrap": "4.6.2",
		"slate": "^0.20.4",
		"slate-drop-or-paste-images": "^0.5.0",
		"slate-edit-list": "^0.7.1",
		"slate-edit-table": "^0.10.1"
	},
	"devDependencies": {
		"add-asset-html-webpack-plugin": "^2.1.2",
		"autoprefixer": "^7.1.0",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.2.3",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.0.0",
		"babel-polyfill": "^6.23.0",
		"babel-preset-react-app": "^3.0.0",
		"babel-runtime": "^6.23.0",
		"case-sensitive-paths-webpack-plugin": "^1.1.4",
		"chalk": "^1.1.3",
		"css-loader": "^0.28.1",
		"dotenv": "^4.0.0",
		"eslint": "^3.19.0",
		"eslint-config-react-app": "^1.0.4",
		"eslint-config-standard": "^10.2.1",
		"eslint-config-standard-react": "^5.0.0",
		"eslint-loader": "^1.7.1",
		"eslint-plugin-flowtype": "^2.33.0",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-jest": "^20.0.3",
		"eslint-plugin-jsx-a11y": "^5.0.3",
		"eslint-plugin-node": "^5.0.0",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-react": "^7.0.1",
		"eslint-plugin-standard": "^3.0.1",
		"extract-text-webpack-plugin": "^2.1.0",
		"file-loader": "^0.11.1",
		"fs-extra": "^4.0.2",
		"html-webpack-plugin": "^2.28.0",
		"identity-obj-proxy": "^3.0.0",
		"jest": "^20.0.3",
		"node-sass": "^4.5.3",
		"postcss-flexbugs-fixes": "^3.0.0",
		"postcss-loader": "^2.0.5",
		"react-dev-utils": "^3.0.0",
		"react-error-overlay": "^1.0.7",
		"react-icons": "^2.2.5",
		"react-test-renderer": "^15.6.1",
		"redux-cli": "^1.9.0",
		"sass-loader": "^6.0.6",
		"style-loader": "^0.17.0",
		"url-loader": "^0.5.8",
		"webpack": "^2.6.1",
		"webpack-dev-server": "^2.4.5",
		"webpack-manifest-plugin": "^1.1.0"
	},
	"jest": {
		"collectCoverageFrom": [
			"src/**/*.{js,jsx}",
			"!src/index.js",
			"!src/App.js"
		],
		"testMatch": [
			"<rootDir>/src/**/__tests__/**/*.js?(x)",
			"<rootDir>/src/**/?(*.)(spec|test).js?(x)"
		],
		"testEnvironment": "node",
		"testURL": "http://localhost",
		"moduleNameMapper": {
			"\\.(css|scss)$": "<rootDir>/node_modules/identity-obj-proxy"
		},
		"transform": {
			"^.+\\.(js|jsx)$": "<rootDir>/node_modules/babel-jest",
			"^(?!.*\\.(js|jsx|css|json)$)": "<rootDir>/config/jest/fileTransform.js"
		},
		"transformIgnorePatterns": [
			"[/\\\\]node_modules[/\\\\].+\\.(js|jsx)$"
		]
	},
	"babel": {
		"presets": [
			"react-app"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 2838
// module chunks = 0